import React, { useCallback, useState } from "react"
import { DataTable } from "@shopify/polaris"
import PropTypes from "prop-types"

import "stylesheets/blocs/organisms/tables/TableOrganism.scss"

const TableOrganism = ({
  tableStructure,
  data,
  hideScrollIndicator,
  initialSortColumnIndex,
}) => {
  const [sortedRows, setSortedRows] = useState([])

  const tableStructureFiltered = tableStructure.filter((table) => !table.hidden)

  const structureByKey = (key) =>
    tableStructureFiltered.map((item) => item[key])

  const selectedInitialSortColumnIndex =
    initialSortColumnIndex ||
    tableStructureFiltered.findIndex((item) => item.sortable)

  const rowByKey = (dataStructure) =>
    dataStructure.map((item) =>
      tableStructureFiltered.map(({ display }) => display(item))
    )

  const initiallyRows = rowByKey(data)
  const headings = structureByKey("header")
  const columnContentTypes = structureByKey("type")
  const sortable = structureByKey("sortable")

  const rows = sortedRows.length ? sortedRows : initiallyRows

  const handleSort = useCallback(
    (index, direction) => {
      const { sortable } = tableStructureFiltered[index]

      const sorted = data.sort((a, b) =>
        direction === "ascending" ? sortable(a, b) : sortable(b, a)
      )

      setSortedRows(rowByKey(sorted))
    },
    [rows, data]
  )

  return (
    <DataTable
      hideScrollIndicator={hideScrollIndicator}
      columnContentTypes={columnContentTypes}
      headings={headings}
      rows={rows}
      sortable={sortable}
      initialSortColumnIndex={selectedInitialSortColumnIndex}
      onSort={handleSort}
      verticalAlign="middle"
      defaultSortDirection="descending"
    />
  )
}

TableOrganism.propTypes = {
  tableStructure: PropTypes.array.isRequired,
  data: PropTypes.array,
  hideScrollIndicator: PropTypes.bool,
  initialSortColumnIndex: PropTypes.number,
}

TableOrganism.defaultProps = {
  tableStructure: [],
  data: [],
  hideScrollIndicator: true,
  initialSortColumnIndex: null,
}

export default TableOrganism
